export default "__VITE_ASSET__11f17442__"